<template>
  <div class="c-banner" :class="`c-banner__bg--${route.meta.banner.bgName}`">
    <div class="c-banner__content">
      <page-title />
    </div>
  </div>
</template>
<script>
import { defineComponent } from 'vue';
import { useRoute } from 'vue-router';
import PageTitle from '@/components/Global/PageTitle.vue';

export default defineComponent({
  name: 'Banner',
  components: {
    PageTitle,
  },
  setup() {
    const route = useRoute();

    return {
      route,
    };
  },
});
</script>

<style lang="scss">
@import '~@/styles/utils/_rwd.scss';

.c-banner {
  margin-top: 85px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  width: 100%;
  height: 289px;
  @include padding(100px 0 250px);

  &__bg {
    &--banner-about {
      background-image: url('~@/assets/img/banner/02.jpg');
    }

    &--banner-course {
      background-image: url('/img/banner/course.png');
    }

    &--banner-donate {
      background-image: url('~@/assets/img/banner/04.jpg');
    }

    &--banner-film {
      background-image: url('/img/banner/film.png');
    }

    &--banner-health-education {
      background-image: url('/img/banner/health-education.png');
    }

    &--banner-member {
      background-image: url('/img/banner/member.png');
    }

    &--banner-news {
      background-image: url('/img/banner/news.png');
    }

    &--banner-resources {
      background-image: url('/img/banner/news.png');
    }

    &--banner-responsibility {
      background-image: url('/img/banner/responsibility.png');
    }

    &--banner-service {
      background-image: url('~@/assets/img/banner/01.jpg');
    }

    &--banner-cherish-story {
      background-image: url('~@/assets/img/banner/02.jpg');
    }

    &--banner-story {
      background-image: url('/img/banner/story.png');
    }

    &--banner-question {
      background-image: url('/img/banner/question.png');
    }

    &--banner-about-story {
      background-image: url('/img/banner/about-story.png');
    }

    &--banner-turn-page {
      background-image: url('~@/assets/img/banner/03.jpg');
    }

    &--banner-self-checking {
      background-image: url('/img/banner/self-checking.png');
    }

    &--banner-related-sites {
      background-image: url('/img/banner/related-sites.png');
    }

    &--banner-qa {
      background-image: url('/img/banner/qa.png');
    }

    &--banner-report {
      background-image: url('/img/banner/report.png');
    }

    &--banner-newsletter {
      background-image: url('/img/banner/newsletter.png');
    }

    &--banner-brochure {
      background-image: url('~@/assets/img/banner/05.jpg');
    }
  }

  &__content {
    @include max-width(1100);
    width: 100%;
    margin-left: auto;
    margin-right: auto;
  }
}

@media screen and (min-width: $tablet) {
  .c-banner {
    margin-top: 0px;
    height: 578px;
    padding-top: 330px;
  }
}
</style>
